import React from "react";

const Styleguide = () => (
  <main>
    <h1>Web typography test</h1>
    <hr />
    <h1>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam nemo
      incidunt aliquid corporis fuga consequatur impedit similique a delectus,
      error corrupti ea dolorum magni nam.
    </h1>
    <h2>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam nemo
      incidunt aliquid corporis fuga consequatur impedit similique a delectus,
      error corrupti ea dolorum magni nam.
    </h2>
    <h3>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam nemo
      incidunt aliquid corporis fuga consequatur impedit similique a delectus,
      error corrupti ea dolorum magni nam.
    </h3>
    <h4>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam nemo
      incidunt aliquid corporis fuga consequatur impedit similique a delectus,
      error corrupti ea dolorum magni nam.
    </h4>
    <h5>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam nemo
      incidunt aliquid corporis fuga consequatur impedit similique a delectus,
      error corrupti ea dolorum magni nam.
    </h5>
    <h6>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam nemo
      incidunt aliquid corporis fuga consequatur impedit similique a delectus,
      error corrupti ea dolorum magni nam.
    </h6>

    <div className="u-grid spc--bottom--med spc--top--med">
      <div className="u-grid-sml__col6 u-grid-lrg__col3">
        <p>
          Lorem idivsum dolor sit amet, consectetur adipisicing elit. Laudantium
          est at ea ut, ad, quibusdam sapiente consectetur perferendis
          doloremque explicabo praesentium quaerat animi magni. Commodi eius
          praesentium, rerum laudantium nostrum excepturi vel corrupti
          architecto id voluptatibus iste ex animi illo dicta provident
          incidunt? Alias, cumque quam, deserunt eaque omnis sed eos incidunt
          repellat eius repudiandae, eum aspernatur quisquam. Vero, sequi.
        </p>
      </div>
      <div className="u-grid-sml__col6 u-grid-lrg__col3">
        <p>
          Lorem idivsum dolor sit amet, consectetur adipisicing elit. Laudantium
          est at ea ut, ad, quibusdam sapiente consectetur perferendis
          doloremque explicabo praesentium quaerat animi magni. Commodi eius
          praesentium, rerum laudantium nostrum excepturi vel corrupti
          architecto id voluptatibus iste ex animi illo dicta provident
          incidunt? Alias, cumque quam, deserunt eaque omnis sed eos incidunt
          repellat eius repudiandae, eum aspernatur quisquam. Vero, sequi.
        </p>
      </div>
      <div className="u-grid-sml__col6 u-grid-lrg__col3">
        <p>
          Lorem idivsum dolor sit amet, consectetur adipisicing elit. Laudantium
          est at ea ut, ad, quibusdam sapiente consectetur perferendis
          doloremque explicabo praesentium quaerat animi magni. Commodi eius
          praesentium, rerum laudantium nostrum excepturi vel corrupti
          architecto id voluptatibus iste ex animi illo dicta provident
          incidunt? Alias, cumque quam, deserunt eaque omnis sed eos incidunt
          repellat eius repudiandae, eum aspernatur quisquam. Vero, sequi.
        </p>
      </div>
      <div className="u-grid-sml__col6 u-grid-lrg__col3">
        <p>
          Lorem idivsum dolor sit amet, consectetur adipisicing elit. Laudantium
          est at ea ut, ad, quibusdam sapiente consectetur perferendis
          doloremque explicabo praesentium quaerat animi magni. Commodi eius
          praesentium, rerum laudantium nostrum excepturi vel corrupti
          architecto id voluptatibus iste ex animi illo dicta provident
          incidunt? Alias, cumque quam, deserunt eaque omnis sed eos incidunt
          repellat eius repudiandae, eum aspernatur quisquam. Vero, sequi.
        </p>
      </div>
    </div>

    <em>emphasize</em>
    <b>bold</b>
    <strong>strong</strong>
    <a href="/styleguide">anchor</a>
    <address>address</address>
    <small>small</small>
    <pre>pre</pre>
    <code>code</code>
    <sub>sub</sub>
    <sup>sup</sup>
    <strike>strike</strike>
    <hr />
    <ul>
      <li>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Architecto
        molestias quibusdam cum molestiae veniam voluptatibus eum porro illo,
        odit tempore eaque, asperiores, dicta eius neque.
      </li>
      <li>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Architecto
        molestias quibusdam cum molestiae veniam voluptatibus eum porro illo,
        odit tempore eaque, asperiores, dicta eius neque.
      </li>
      <li>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Architecto
        molestias quibusdam cum molestiae veniam voluptatibus eum porro illo,
        odit tempore eaque, asperiores, dicta eius neque.
      </li>
    </ul>
    <ol>
      <li>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Architecto
        molestias quibusdam cum molestiae veniam voluptatibus eum porro illo,
        odit tempore eaque, asperiores, dicta eius neque.
      </li>
      <li>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Architecto
        molestias quibusdam cum molestiae veniam voluptatibus eum porro illo,
        odit tempore eaque, asperiores, dicta eius neque.
      </li>
      <li>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Architecto
        molestias quibusdam cum molestiae veniam voluptatibus eum porro illo,
        odit tempore eaque, asperiores, dicta eius neque.
      </li>
    </ol>
    <dl>
      <dt>Lorem ipsum dolor sit amet.</dt>
      <dd>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda,
        veritatis architecto sint totam repellat similique exercitationem aut
        suscipit placeat ex.
      </dd>
      <dt>Lorem ipsum dolor sit amet.</dt>
      <dd>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda,
        veritatis architecto sint totam repellat similique exercitationem aut
        suscipit placeat ex.
      </dd>
      <dt>Lorem ipsum dolor sit amet.</dt>
      <dd>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda,
        veritatis architecto sint totam repellat similique exercitationem aut
        suscipit placeat ex.
      </dd>
    </dl>
    <table description="Table description">
      <caption>Table caption</caption>
      <thead>
        <tr>
          <th>Header content 1</th>
          <th>Header content 2</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Body content 1</td>
          <td>Body content 2</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td>Footer content 1</td>
          <td>Footer content 2</td>
        </tr>
      </tfoot>
    </table>

    <div className="spc--bottom--lrg spc--top--med">
      <h4>Buttons</h4>
      <button className="btn btn--ghost btn--med">Ghost button</button>
      <button className="btn btn--primary btn--med">Primary button</button>
      <button className="btn btn--secondary btn--med">Secondary button</button>

      <h4>Button sizes</h4>
      <button className="btn btn--primary btn--sml">Button sml</button>
      <button className="btn btn--primary btn--med">Button med</button>
      <button className="btn btn--primary btn--lrg">Button lrg</button>
    </div>
  </main>
);

export default Styleguide;



// WEBPACK FOOTER //
// ./src/views/Styleguide.jsx